import React, { useState, useEffect } from "react";
import moment from "moment";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

const LittleCalendar = ({
  currentMonth,
  selectedDay,
  generateDaysArray,
  setDayselected,
  appointments,
  events,
}) => {
  const [currentDate, setCurrentDate] = useState(moment(currentMonth));
  const [days, setDays] = useState([]);
  const formaMonth = currentDate.format("MMMM YYYY");

  useEffect(() => {
    setDays(generateDaysArray(currentDate, selectedDay, appointments));
  }, [currentDate, selectedDay]);

  const handlePreviousMonth = () => {
    setCurrentDate(currentDate.clone().subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentDate(currentDate.clone().add(1, "month"));
  };

  return (
    <div className="sticky top-8 hidden w-1/2 max-w-md flex-none border-l border-wa-border bg-wa-panel px-8 py-10 md:block">
      <div className="flex items-center text-center text-wa-text">
        <button
          type="button"
          onClick={handlePreviousMonth}
          className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Previous month</span>
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <div className="flex-auto text-sm font-semibold">
          {formaMonth}
        </div>
        <button
          type="button"
          onClick={handleNextMonth}
          className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Next month</span>
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      <div className="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-wa-muted">
        <div>Ma</div>
        <div>Di</div>
        <div>Woe</div>
        <div>Do</div>
        <div>Vr</div>
        <div>Za</div>
        <div>Zo</div>
      </div>
      <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-wa-border text-sm shadow ring-1 ring-wa-border">
        {days.map((day, dayIdx) => (
          <button
            key={day.date}
            type="button"
            onClick={() => setDayselected(day)}
            className={classNames(
              "py-1.5 hover:bg-gray-100 focus:z-10",
              day.isCurrentMonth
                ? (day.isSelected && !day.isToday
                    ? "bg-wa-hover"
                    : "bg-wa-panel2")
                : "bg-slate-500 text-wa-text/80",
              day.isSelected &&
                `font-semibold ${
                  day.events.length > 0
                    ? "bg-wa-rowhover"
                    : "bg-wa-hover"
                }`,
              day.isToday && "text-wa-onaccent",
              !day.isCurrentMonth && !day.isToday && "text-gray-400",
              dayIdx === 0 && "rounded-tl-lg",
              dayIdx === 6 && "rounded-tr-lg",
              dayIdx === days.length - 7 && "rounded-bl-lg",
              dayIdx === days.length - 1 && "rounded-br-lg"
            )}
          >
            <time
              dateTime={day.date}
              className={classNames(
                "mx-auto flex h-7 w-7 items-center justify-center rounded-full",
                day.isSelected && day.isToday && "bg-wa-accent",
                day?.events?.length > 0 && "bg-wa-accent text-wa-onaccent",
                day.isToday && "bg-wa-accentdeep"
              )}
            >
              {day.date.split("-").pop().replace(/^0/, "")}
            </time>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LittleCalendar;

// Helper function for class names (you can also use a library like clsx)
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
